import Apify from '@wetransfer/transfer/modules/apify';

const methods = {
  fetchWallpapers: {
    path: '/api/v4/channels/{name}/wallpapers',
    pathExt: true,
  },
};

export const ChannelsAPI = Apify<typeof methods>(methods);
